import * as React from "react";
import { cn } from "@/lib/utils";

export interface BottomNavProps {
  variant: "worker" | "admin";
  children: React.ReactNode;
  className?: string;
}

export function BottomNav({ variant, children, className }: BottomNavProps) {
  const items = React.Children.toArray(children);
  const itemCount = items.length;
  // Centered FAB notch only works when item count is even (item count + spacer = odd slots,
  // so the middle slot lands on the spacer at 50%). With odd N we drop the notch and let the
  // caller position the FAB off-center.
  const useNotch = variant === "worker" && itemCount > 0 && itemCount % 2 === 0;
  return (
    <nav
      className={cn(
        "fixed inset-x-0 bottom-0 h-16 border-t border-line bg-surface pb-[env(safe-area-inset-bottom)] [view-transition-name:vroom-bottom-nav]",
        className,
      )}
      style={{
        viewTransitionName: "vroom-bottom-nav",
        ...(useNotch
          ? {
              WebkitMaskImage:
                "radial-gradient(circle 33px at 50% 0, transparent 32px, black 33px)",
              maskImage: "radial-gradient(circle 33px at 50% 0, transparent 32px, black 33px)",
            }
          : {}),
      }}
    >
      <div className="flex h-full">
        {items.map((child, i, arr) => (
          <React.Fragment key={i}>
            {child}
            {useNotch && i === Math.floor(arr.length / 2) - 1 ? (
              <div className="flex-1" aria-hidden />
            ) : null}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
}
